import { SaveStatus } from 'lib-shared-legacy-types';
import { useCallback, useState } from 'react';

export type SaveStatusData = {
  setStatusToSaved: () => void;
  setStatusToUnsaved: () => void;
  hasUnsavedChanges: boolean;
  saveStatus: SaveStatus;
};

export function useSaveStatusState(
  initialState = SaveStatus.Saved,
): SaveStatusData {
  const [saveStatus, setSaveStatus] = useState(initialState);

  const hasUnsavedChanges = saveStatus <= SaveStatus.Unsaved;

  const setStatusToUnsaved = useCallback(() => {
    setSaveStatus(SaveStatus.Unsaved);
  }, [setSaveStatus]);

  const setStatusToSaved = useCallback(() => {
    setSaveStatus(SaveStatus.Saved);
  }, [setSaveStatus]);

  return {
    saveStatus,
    setStatusToSaved,
    setStatusToUnsaved,
    hasUnsavedChanges,
  };
}
